const MATIC_CHAINLINK_MAPPING = {
  // AAVE / ETH
  '0xbE23a3AA13038CfC28aFd0ECe4FdE379fE7fBfc4': {
    from: '0xD6DF932A45C0f255f85145f286eA0b292B21C90B',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  // BOND / USD
  '0x58527C2dCC755297bB81f9334b80b2B6032d8524': {
    from: '0xA041544fe2BE56CCe31Ebb69102B965E06aacE80',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // BTC / USD
  /*'0xc907E116054Ad103354f2D350FD2514433D57F6f': {
    from: '',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },*/
  // BZRX / USD
  // '0x6b7D436583e5fE0874B7310b74D29A13af816860': {
  //   from: '0x54cFe73f2c7d0c4b62Ab869B473F5512Dc0944D2',
  //   to: '0x0000000000000000000000000000000000000001',
  //   decimals: 8,
  //   fromDecimals: 18,
  //   toDecimals: 8,
  // },
  // CEL / USD
  '0xc9ECF45956f576681bDc01F79602A79bC2667B0c': {
    from: '0xD85d1e945766Fea5Eda9103F918Bd915FbCa63E6',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // CRV / ETH
  '0x1CF68C76803c9A415bE301f50E82e44c64B7F1D4': {
    from: '0xD533a949740bb3306d119CC777fa900bA034cd52',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  // DAI /ETH
  '0xFC539A559e170f848323e19dfD66007520510085': {
    from: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  // DAI / USD
  '0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D': {
    from: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // DOGE / USD
  '0xbaf9327b6564454F4a3364C33eFeEf032b4b4444': {
    from: '0x7C4A54f5d20b4023D6746F1f765f4DFe7C39a7e6',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // ETH / USD
  '0xF9680D99D6C9589e2a93a78A04A279e509205945': {
    from: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // FXS / USD
  '0x6C0fe985D3cAcbCdE428b84fc9431792694d0f51': {
    from: '0x3e121107F6F22DA4911079845a470757aF4e1A1b',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // JPY / USD
  '0xD647a6fC9BC6402301583C91decC5989d8Bc382D': {
    from: '0x6AE7Dfc73E0dDE2aa99ac063DcF7e8A63265108c',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // LINK /ETH
  '0xb77fa460604b9C6435A235D057F7D319AC83cb53': {
    from: '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  // LINK / USD
  '0xd9FFdb71EbE7496cC440152d43986Aae0AB76665': {
    from: '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // MATIC / ETH
  '0x327e23A4855b6F663a28c5161541d69Af8973302': {
    from: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  // MATIC / USD
  '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0': {
    from: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // MFT / USD
  '0x6E53C1c22427258BE55aE985a65c0C87BB631F9C': {
    from: '0x91cA694d2B293f70Fe722fbA7d8A5259188959c3',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // MKR / ETH
  '0x807b59d12520830D1864286FA0271c27baa94197': {
    from: '0x6f7C932e7684666C9fd1d44527765433e01fF61d',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  // RCN / BTC
  '0x040DACDA344a026350f6884ec212c405a1616506': {
    from: '0x89C296Be2F904F3e99a6125815b4B78F5388d2dd',
    to: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  // SAND / USD
  '0x3D49406EDd4D52Fb7FFd25485f32E073b529C924': {
    from: '0xC6d54D2f624bc83815b49d9c2203b1330B841cA0',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // SNX / USD
  '0xbF90A5D9B6EE9019028dbFc2a9E50056d5252894': {
    from: '0x50B728D8D964fd00C2d0AAD81718b71311feF68a',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // SUSHI / USD
  '0x49B0c695039243BBfEb8EcD054EB70061fd54aa0': {
    from: '0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // UNI / ETH
  '0x162d8c5bF15eB6BEe003a1ffc4049C92114bc931': {
    from: '0xb33EaAd8d922B1083446DC23f610c2567fB5180f',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  },
  // USDC / ETH
  '0xefb7e6be8356cCc6827799B6A7348eE674A80EaE': {
    from: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 6,
    toDecimals: 18,
  },
  // USDC / USD
  '0xfE4A8cc5b5B2366C1B58Bea3858e81843581b2F7': {
    from: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 6,
    toDecimals: 8,
  },
  // USDT / ETH
  '0xf9d5AAC6E5572AEFa6bd64108ff86a222F69B64d': {
    from: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 6,
    toDecimals: 18,
  },
  // USDT / USD
  '0x0A6513e40db6EB1b165753AD52E80663aeA50545': {
    from: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 6,
    toDecimals: 8,
  },
  // WBTC / ETH
  '0xA338e0492B2F944E9F8C0653D3AD1484f2657a37': {
    from: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 8,
    fromDecimals: 8,
    toDecimals: 18,
  },
  // WBTC / USD
  '0xc907E116054Ad103354f2D350FD2514433D57F6f': {
    from: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // YFI / ETH
  '0x9896A1eA7A00F5f32Ab131eBbeE07487B0af31D0': {
    from: '0xb8cb8a7F4C2885C03e57E973C74827909Fdc2032',
    to: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    decimals: 18,
    fromDecimals: 18,
    toDecimals: 18,
  }, // RAI / USD
  '0x7f45273fD7C644714825345670414Ea649b50b16': {
    from: '0x00e5646f60AC6Fb446f621d146B6E1886f002905',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // COMP / USD
  '0x2A8758b7257102461BC958279054e372C2b1bDE6': {
    from: '0x8505b9d2254A7Ae468c0E9dd10Ccea3A837aef5c',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // UMA / USD
  '0x33D9B1BAaDcF4b26ab6F8E83e9cb8a611B2B3956': {
    from: '0x3066818837c5e6eD6601bd5a91B0762877A6B731',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // ALCX / USD
  '0x5DB6e61B6159B20F068dc15A47dF2E5931b14f29': {
    from: '0x95c300e7740D2A88a44124B424bFC1cB2F9c3b89',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // BAL / USD
  '0xD106B538F2A868c28Ca1Ec7E298C3325E0251d66': {
    from: '0x9a71012B13CA4d3D0Cdc72A177DF3ef03b0E76A3',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
}

export default MATIC_CHAINLINK_MAPPING
